import { notifyOnError } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { CharacterLicense } from '~/shared';
import { GameConfigService } from '../GameConfigService';
import { LicensesService } from '../LicensesService';
import { RpcService } from '../RpcService';
import {
	IDrivingSchoolExam,
	IDrivingSchoolService,
} from './drivingSchoolServiceTypes';

export class DrivingSchoolService implements IDrivingSchoolService {
	private exams = new Subject<IDrivingSchoolExam[]>([]);

	constructor(
		private readonly rpc: RpcService,
		private readonly gameConfig: GameConfigService,
		private readonly licenses: LicensesService,
	) {
		this.gameConfig.getConfigs().subscribe(() => {
			this.fetchExams();
		});
	}

	public fetchExams(): void {
		const drivingSchoolExams = [];
		const exams = this.gameConfig.configs?.drivingSchool?.exams;
		const licenses = this.licenses.getLicenses().getValue();

		if (exams) {
			for (const exam of exams) {
				const license = licenses.find((e) => e.id === exam.id);

				if (!license) {
					continue;
				}

				drivingSchoolExams.push({
					id: exam.id,
					name: license.name,
					letter: license.letter,
					price: exam.price,
					isOwned: license.isOwned,
				});
			}
		}

		this.exams.next(drivingSchoolExams);
	}

	public getExams(): IObservable<IDrivingSchoolExam[]> {
		return this.exams;
	}

	@notifyOnError
	public async startExam(licenseId: CharacterLicense): Promise<void> {
		await this.rpc.invokeServer('drivingSchool:startExam', { licenseId });
		await this.exit();
	}

	public async exit(): Promise<void> {
		await this.rpc.invokeClient('drivingSchool:exit');
	}
}
